interface RestrictedAccessGateProps {
  children: React.ReactNode;
}

export function RestrictedAccessGate({
  children,
}: RestrictedAccessGateProps) {
  return <>{children}</>;
}
